import { render, staticRenderFns } from "./LuckDeliveryForm.vue?vue&type=template&id=954fbfca&scoped=true"
import script from "./LuckDeliveryForm.vue?vue&type=script&lang=js"
export * from "./LuckDeliveryForm.vue?vue&type=script&lang=js"
import style0 from "./LuckDeliveryForm.vue?vue&type=style&index=0&id=954fbfca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "954fbfca",
  null
  
)

export default component.exports